import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { NotificationContentProps } from "../../types";

export default function DiscussionApproval({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussionApproval"
      values={{
        name: util.getEventNames(events ?? []),
        group: ownerGroup?.name || "Deleted",
      }}
      components={{ b: <b />, formattedComment: <FormattedComment noLink /> }}
    />
  );
}
